'use client';

import { useDispatch } from 'react-redux';

import useInAppNotifications from './useInAppNotifications';
import { removeInternalNotification } from 'store/reducers/InternalNotificationsSlice';
import { InternalNotificationsTypes } from 'types/internalNotifications';
import { IdType } from 'types/common';

const useInternalNotifications = (disabledTypes = []) => {
  const dispatch = useDispatch();

  const inAppTypeDisabled = disabledTypes.includes(InternalNotificationsTypes.IN_APP);

  const { inAppNotifications } = useInAppNotifications({ disabled: inAppTypeDisabled });

  const onDelete = (id: IdType, isInApp: boolean) => {
    const type = isInApp ? InternalNotificationsTypes.IN_APP : InternalNotificationsTypes.USER;

    dispatch(removeInternalNotification({ id, type }));
  };

  const mergeNotifications = () => {
    let notifications = [];

    if (!inAppTypeDisabled) {
      notifications = [...notifications, ...inAppNotifications];
    }

    return notifications;
  };

  return { notifications: mergeNotifications(), onDelete };
};

export default useInternalNotifications;
